import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <MediaSection />
        <IndexSection />
        <CommentsSection />
        <AppSection />
        <UpdatesSection />
        <RankingSection />
        <ContactSection />
        <CarouselSection />
        <AboutSection />
        <FaqSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}